import { http } from "@/lib/http";
export function fetchPointsBreakdown() {
  return http
    .get("/api/campaigns/getPoints")
    .then((res) => res.data?.data?.points_breakdown || []);
}
export function updatePointsBreakdown(breakdown) {
  return http
    .post("/api/campaigns/updatePoints", breakdown)
    .then((res) => res.data);
}
